import { render, staticRenderFns } from "./AddVoucherModal.vue?vue&type=template&id=b2a80412&scoped=true"
import script from "./AddVoucherModal.vue?vue&type=script&lang=ts"
export * from "./AddVoucherModal.vue?vue&type=script&lang=ts"
import style0 from "./AddVoucherModal.vue?vue&type=style&index=0&id=b2a80412&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a80412",
  null
  
)

export default component.exports